/*@ngInject*/
export default function homeRoutes($stateProvider) {
    $stateProvider
        .state('home', {
            url: '/',
            templateUrl: '/views/index'
        });
}